import { render, staticRenderFns } from "./TeamsMeeting.vue?vue&type=template&id=ae71be74&"
import script from "./TeamsMeeting.vue?vue&type=script&lang=js&"
export * from "./TeamsMeeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae71be74')) {
      api.createRecord('ae71be74', component.options)
    } else {
      api.reload('ae71be74', component.options)
    }
    module.hot.accept("./TeamsMeeting.vue?vue&type=template&id=ae71be74&", function () {
      api.rerender('ae71be74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/Meeting/TeamsMeeting.vue"
export default component.exports